module.exports = __webpack_public_path__ + "static/img/leftshape.971448e.png";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/registerflow-new/leftshape.png
// module id = DKvF
// module chunks = 4